import { AfterViewInit, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FilterOption, SafeAny } from '@pf/shared-common';
import {
    debounceTime,
    distinctUntilChanged,
    map,
    Observable,
    of,
    skipUntil,
} from 'rxjs';
import { BaseFilterComponent } from './base-filter.component';

@UntilDestroy()
@Component({
    selector: 'pf-switch-filter',
    templateUrl: './switch-filter.component.html',
    styleUrl: './switch-filter.component.scss',
    standalone: false,
})
export class SwitchFilterComponent
    extends BaseFilterComponent
    implements AfterViewInit
{
    checkedControl = new FormControl<boolean>(false, { nonNullable: true });

    private _syncing = false;

    ngAfterViewInit(): void {
        this.filterService
            .getAppliedFilterByName$(this.filterName)
            .pipe(
                skipUntil(this.filtersAreReady$ ?? of(true)),
                untilDestroyed(this),
                debounceTime(300),
                map(f => {
                    if (!f) {
                        return false;
                    }
                    return (
                        f.value === true ||
                        (Array.isArray(f.value) && f.value.length > 0)
                    );
                }),
                distinctUntilChanged()
            )
            .subscribe(on => {
                this._syncing = true;
                this.checkedControl.setValue(on, { emitEvent: false });
                this._syncing = false;
            });

        this.checkedControl.valueChanges
            .pipe(
                skipUntil(this.filtersAreReady$ ?? of(true)),
                untilDestroyed(this)
            )
            .subscribe(() => {
                if (this._syncing) {
                    return;
                }
                this.filterChangedChecks();
            });
    }

    override setFilterOptions(
        _options: FilterOption[] | Observable<FilterOption[]> | undefined
    ): void {
        void _options;
    }

    override validate(): void {
        return;
    }

    override filterChangedChecks(): void {
        const checked = this.checkedControl.value;
        this.filterChangeHandler({
            name: this.filterName,
            key: this.filterKey,
            value: checked ? true : undefined,
        });
    }

    override filterResetFn(): void {
        this._syncing = true;
        this.checkedControl.setValue(false, { emitEvent: false });
        this._syncing = false;
    }

    override filterClearFn(): void {
        this.filterResetFn();
    }

    override updateInitialFilter(_: SafeAny): void {
        return;
    }
}
